import { render } from "./SpamNumberListSort.vue?vue&type=template&id=0bd59830&ts=true"
import script from "./SpamNumberListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpamNumberListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/spam-number/components/SpamNumberListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bd59830"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bd59830', __exports__)) {
    api.reload('0bd59830', __exports__)
  }
  
  module.hot.accept("./SpamNumberListSort.vue?vue&type=template&id=0bd59830&ts=true", () => {
    api.rerender('0bd59830', render)
  })

}


export default __exports__